<template>
  <div id="language-translations" class="row">
    <form id="translate-language-form" class="small-12 columns" @submit.prevent="submitForm">
      <label>
        {{ 'Language'|t }}
        <input class="uppercase" type="text" v-model="lang" required="required" maxlength="2" pattern="[A-Za-z]{2}" size="4" />
      </label>

      <fieldset>
        <legend>{{ 'Translations'|t }}</legend>

        <table v-if="translations.length > 0">
          <tr v-for="(item, index) in translations" :key="index" :model="translations">
            <td>
              <input type="text" :value="item.src" :data-index="index" @change="changeSource" />
            </td>
            <td class="text-center">
              <i class="icon icon-arrow-right2"></i>
            </td>
            <td>
              <input type="text" :value="item.trn" :data-index="index" @change="changeTrn" />
            </td>
            <td>
              <button @click.prevent="removeLine(index)" class="clear expanded alert button"><i class="icon icon-bin"></i></button>
            </td>
          </tr>
        </table>

        <button @click.prevent="addLine" class="hollow button"><i class="icon icon-plus"></i> {{ 'Add'|t }}</button>
      </fieldset>

      <input type="submit" name="submit" :value="'Submit'|t" class="medium expanded success button" :disabled="hasTranslation() ? null : 'disabled'"/>
    </form>
  </div>
</template>

<script>
  import Vue from 'vue'
  import api from '@/api';
  import router from '@/routes';

  export default {
    name: 'LanguageForm',
    props: {
      langcode: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        lang: "",
        translations: [],
      }
    },
    created() {
      if (typeof this.langcode === "undefined" || this.langcode === "") {
        return;
      }

      let self = this;
      api.getFrontendTranslation(
        {lang: self.langcode.toUpperCase()},
        data => {
          self.lang = data.lang;
          for (let key in data.translations){
            if (data.translations.hasOwnProperty(key)) {
              if (key.length > 0 && data.translations[key].length > 0) {
                this.translations.push({src: key, trn: data.translations[key]})
              }
            }
          }
        }
      );
    },
    methods: {
      submitForm() {
        let request = {
          lang: this.lang.toUpperCase(),
          translations: {}
        };

        for (let i in this.translations) {
          request.translations[this.translations[i].src] = this.translations[i].trn;
        }

        api.setFrontendTranslation(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Settings have been saved.",
            }, {root: true});
            router.push({name: 'frontend.settings'});
          }
        );
      },
      addLine() {
        this.translations.push({src: "", trn: ""});
      },
      removeLine(delta) {
        Vue.delete(this.translations, delta);
      },
      changeSource(ev) {
        this.translations[ev.target.dataset.index].src = ev.target.value;
      },
      changeTrn(ev) {
        this.translations[ev.target.dataset.index].trn = ev.target.value;
      },
      hasTranslation() {
        if (this.translations.length === 0) {
          return false;
        }
        for (let i in this.translations) {
          if ('src' in this.translations[i] && 'trn' in this.translations[i] && this.translations[i].src.length > 0 && this.translations[i].trn.length > 0) {
            return true
          }
        }
        return false;
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/frontend/LanguageForm.vue